import Input from 'features/common/components/Input'
import {useTypedTranslation} from 'i18n'
type FormInputType = {
    error?: string
} & Parameters<typeof Input>[0]
const FormInput = ({error, ...props}: FormInputType) => {
    const {t} = useTypedTranslation()
    return (
        <div className="flex w-full flex-col">
            <Input
                className="h-9 min-w-0 flex-initial basis-9 text-sm"
                {...props}
            />
            {error && (
                <div className="pl-4 text-xs text-red-700">{t(error)}</div>
            )}
        </div>
    )
}

export default FormInput
